/**
 * Base64 encoding/decoding utilities with UTF-16 support
 * These functions safely handle UTF-16 strings in base64 encoding
 */

/**
 * Safely encode UTF-16 strings to base64
 * Handles Unicode characters properly by using encodeURIComponent
 * 
 * @param str - The UTF-16 string to encode
 * @returns Base64 encoded string
 */
export const encodeBase64 = (str: string): string => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => {
    return String.fromCharCode(parseInt(p1, 16));
  }));
};

/**
 * Safely decode base64 to UTF-16 strings  
 * Handles Unicode characters properly by using decodeURIComponent
 * 
 * @param str - The base64 encoded string to decode
 * @returns Decoded UTF-16 string
 */
export const decodeBase64 = (str: string): string => {
  return decodeURIComponent(atob(str).split('').map(c => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
};